import ApiService from '../services/api.service'
import { PlcOperationStateHistoryItemModel } from './models'

export default {
  async loadPlcOperationStateHistory(plcId: string): Promise<PlcOperationStateHistoryItemModel[]> {
    const response = await ApiService.get(`${ApiService.backendEnvironmentConfiguration().plcOperationQueryApi}/PlcOperationState/${plcId}/history`)
    return response.data.value
  },
}
